import React, { useState, useEffect, useRef } from "react";

// Large pool of common Asian names by country - 1000+ names (NO celebrities/famous people)
const NAME_POOLS = {
  india: [
    "Amit Kumar", "Rahul Sharma", "Vijay Singh", "Sunil Verma", "Rajesh Gupta", "Arun Patel",
    "Sanjay Mishra", "Manoj Yadav", "Deepak Tiwari", "Rakesh Pandey", "Mukesh Agarwal", "Suresh Joshi",
    "Ramesh Dubey", "Naresh Sinha", "Dinesh Rastogi", "Pankaj Saini", "Gaurav Saxena", "Sandeep Chopra",
    "Alok Bansal", "Abhishek Das", "Rohit Nair", "Manish Reddy", "Ajay Iyer", "Tarun Menon",
    "Rajeev Pillai", "Saurabh Kulkarni", "Vikram Desai", "Anil Bhatt", "Ravi Thakur", "Ashok Choudhary",
    "Pradeep Arora", "Vivek Sethi", "Nitin Khanna", "Lalit Bhatia", "Mohan Grover", "Kishore Ahuja",
    "Gopal Malhotra", "Shiv Kapoor", "Om Mehra", "Brij Tandon", "Satish Oberoi", "Rajendra Anand",
    "Virendra Dhawan", "Mahesh Vohra", "Surender Walia", "Devendra Khurana", "Chander Suri", "Balwant Luthra",
    "Gurpreet Gill", "Jaspreet Sidhu", "Kuldeep Sandhu", "Amarjeet Brar", "Parminder Dhillon", "Sukhwinder Grewal",
    "Lakhwinder Bajwa", "Harvinder Sahota", "Balvinder Randhawa", "Tejinder Cheema", "Varinder Chahal", "Joginder Sekhon",
    "Mohinder Bassi", "Narinder Multani", "Satinder Sohal", "Yashpal Rana", "Trilok Rawat", "Omprakash Negi",
    "Ramkumar Bisht", "Shyamlal Jangid", "Parmod Shekhawat", "Satyanarayan Meena", "Hariom Gurjar", "Ghanshyam Ola",
    "Badrinath Prajapat", "Vishwanath Sharma", "Mahavir Choudhary", "Ramashray Yadav", "Lalbahadur Maurya", "Dayashankar Verma",
    "Chandrabhan Gupta", "Awadhesh Singh", "Raghunandan Mishra", "Brijkishore Tripathi", "Shivpujan Pandey", "Baleshwar Tiwari",
    "Ramashish Dubey", "Jitendra Shukla", "Umesh Srivastava", "Ramanand Awasthi", "Krishnakant Bajpai", "Tribhuvan Dixit",
    "Shailendra Pathak", "Nagendra Upadhyay", "Dharmendra Nigam", "Sachindra Bhatnagar", "Jogendra Agrawal", "Mahendra Garg",
    "Raju Prasad", "Pappu Kumar", "Guddu Lal", "Tinku Babu", "Pintu Ram", "Rinku Das",
    "Sonu Mandal", "Monu Thakur", "Golu Singh", "Bablu Rai", "Kallu Chauhan", "Lallu Prajapati",
    "Vijay Pal", "Suraj Bhan", "Chotu Ram", "Nanhe Lal", "Mange Ram", "Phool Chand",
    "Hari Shankar", "Ram Swaroop", "Shyam Sunder", "Ganga Ram", "Yamuna Prasad", "Krishna Kumar",
    "Radhe Shyam", "Bansi Lal", "Murli Dhar", "Gopal Das", "Nand Kishore", "Bal Krishna",
    "Jai Prakash", "Surya Narayan", "Chandra Bhushan", "Aditya Vikram", "Arjun Pratap", "Bhanu Priya",
    "Chetan Raj", "Dhananjay Mohan", "Eklavya Nath", "Farooq Ansari", "Ghulam Hussain", "Hamid Sheikh",
    "Irshad Ali", "Javed Khan", "Karim Bhai", "Latif Mirza", "Majid Qureshi", "Nasir Ahmad",
    "Rahim Shaikh", "Salim Pathan", "Tariq Mohammad", "Umar Farooq", "Wasim Aktar", "Yakub Malik",
    "Zaheer Hussain", "Aslam Raza", "Bashir Ahmed", "Chand Mohammad", "Danish Anwar", "Ejaz Alam",
    "Feroz Khan", "Gulzar Beg", "Haider Abbas", "Ikram Uddin", "Jameel Syed", "Khalid Rashid",
    "Liaquat Ali", "Manzoor Akhtar", "Nadeem Asghar", "Pervez Shah", "Qasim Rizvi", "Rashid Siddiqui",
    "Shakeel Ahmad", "Tanveer Alam", "Usman Ghani", "Waqar Hasan", "Yaseen Baig", "Zubair Hashmi",
    "Akbar Ali", "Bahadur Shah", "Daulat Ram", "Faiz Mohammad", "Habib Rahman", "Iqbal Singh",
    "Jagtar Kumar", "Karan Deep", "Lakhan Lal", "Makhan Singh", "Nanak Chand", "Onkar Nath",
    "Partap Singh", "Raghu Vir", "Sukha Ram", "Tara Chand", "Uttam Kumar", "Ved Prakash",
    "Anand Mohan", "Bhuvan Kumar", "Chaman Lal", "Dharam Singh", "Eknath Rao", "Fakir Chand",
    "Ganpat Rai", "Hanuman Das", "Ishwar Dayal", "Jagjit Pal", "Keshav Ram", "Lalman Singh",
    "Mangal Sen", "Nathuram Lal", "Omkar Prasad", "Phoolchand Verma", "Raghubir Sahay", "Sitaram Yadav",
    "Tulsi Das", "Udai Bhan", "Virender Pal", "Wazir Singh", "Yadvinder Lal", "Ziauddin Khan"
  ],
  pakistan: [
    "Abbas Ali", "Bilal Hussain", "Usman Khan", "Imran Ahmed", "Faisal Mahmood", "Hassan Raza",
    "Kamran Akhtar", "Naveed Aslam", "Adnan Siddiqui", "Waqar Hasan", "Junaid Iqbal", "Rizwan Shah",
    "Zahid Ullah", "Shahzad Amir", "Khalid Bashir", "Tariq Pervaiz", "Arshad Saleem", "Nasir Javed",
    "Saleem Gul", "Sajid Nawaz", "Rashid Yousuf", "Farhan Latif",
    "Ali Hassan", "Shakeel Durrani", "Waheed Kakar", "Zubair Marwat", "Kashif Khattak",
    "Irfan Bangash", "Nadeem Orakzai", "Aamir Mohmand", "Tanveer Shinwari", "Javed Yousafzai", "Mushtaq Wazir",
    "Pervaiz Mehsud", "Zafar Dawar", "Manzoor Zadran", "Aslam Bajaur", "Akram Swati", "Shafiq Buner",
    "Liaqat Malakand", "Ghulam Dir", "Iftikhar Chitral", "Rafiq Kohistan", "Sarfraz Mansehra", "Nisar Abbottabad",
    "Hanif Haripur", "Sabir Swabi", "Mazhar Nowshera", "Riaz Charsadda", "Ansar Takht", "Bashir Karak",
    "Arif Lakki", "Shabbir Bannu", "Qamar Tank", "Azhar Dera", "Ehsan Kohat", "Mudassar Hangu",
    "Fawad Kurram", "Hamza Parachinar", "Talha Wana", "Usama Miranshah", "Anas Mir Ali", "Saad Razmak",
    "Fahad Datta", "Ahsan Zhob", "Danish Qilla", "Owais Loralai", "Kamil Khuzdar",
    "Mohsin Turbat", "Nabeel Gwadar", "Umair Pasni", "Waqas Ormara", "Yasir Lasbela", "Zohaib Hub",
    "Awais Karachi", "Bilal Hyderabad", "Chaudhry Sukkur", "Dawood Larkana", "Ehsaan Nawabshah", "Farrukh Mirpurkhas",
    "Gohar Sanghar", "Hamid Badin", "Ijaz Thatta", "Jahangir Dadu", "Khurram Jamshoro", "Luqman Matiari",
    "Mansoor Tando", "Noman Umerkot", "Osama Mithi", "Qadeer Nagarparkar", "Rehan Tharparkar", "Sohail Kashmore",
    "Taimoor Rashid", "Umer Shikarpur", "Wahab Ghotki", "Yawar Khairpur", "Zulfiqar Sukkur", "Ahmed Rohri",
    "Bilawal Pano", "Faizan Kotri", "Haider Sehwan", "Imad Hala", "Junaid Bhan", "Kashif Tando",
    "Latif Digri", "Mirza Kunri", "Naseem Naukot", "Omar Samaro", "Parvez Chor", "Qazi Diplo",
    "Rana Islamkot", "Samir Chachro", "Tahir Kaloi", "Usaid Nangarparkar", "Viqar Mithi", "Wamiq Umerkot",
    "Younis Mirpur", "Zain Bhimber", "Adeel Kotli", "Basit Rawalakot", "Farhad Bagh", "Ghulam Poonch",
    "Hammad Sudhanoti", "Imran Haveli", "Jamshed Muzaffarabad", "Kamil Hattian", "Liaquat Neelum", "Misbah Sharda",
    "Nauman Athmuqam", "Obaid Kel", "Pervez Dudnial", "Qaiser Dawarian", "Rafat Nagdar", "Sajjad Chakkar",
    "Talat Chikar", "Umar Shounter", "Wajid Taobutt", "Yaqub Minimarg", "Zahoor Kail", "Anwar Halmat",
    "Badar Lawat", "Changez Shontar", "Dildar Upper", "Ejaz Lower", "Fayyaz Jones", "Ghazi Skardu",
    "Haris Shigar", "Israr Khaplu", "Jamal Ghanche", "Kamal Rondu", "Latif Gilgit", "Mehmood Hunza",
    "Niaz Nagar", "Omer Gahkuch", "Pervaiz Gupis", "Qayyum Yasin", "Rehmat Ishkoman", "Shams Phander",
    "Tariq Chitral", "Ubaid Mastuj", "Waris Booni", "Yusuf Drosh", "Zeeshan Ayun", "Abdullah Garam",
    "Behram Lun", "Feroz Reshun", "Gohar Shagram", "Humayun Barenis", "Ihsan Shishi", "Jaffar Koghuzi",
    "Kazim Torkhow", "Liaqat Mulkhow", "Mumtaz Parsan", "Noor Arkari", "Owais Awi", "Parvez Terich",
    "Qadeem Shahgram", "Rahim Rich", "Shamim Golen", "Tausif Brep", "Umer Rumbur", "Vaqar Bumburet",
    "Wasif Birir", "Yar Kalash", "Asim Laspur", "Basharat Shandur", "Changez Barat",
    "Akmal Butt", "Bilal Jatt", "Daniyal Rajput", "Ehsan Gujjar", "Furrukh Awan", "Ghazanfar Malik",
    "Hamid Dogar", "Ijlal Virk", "Jawad Cheema", "Kamil Gondal", "Liaquat Khokhar", "Mujahid Warraich",
    "Naeem Arain", "Obaid Sial", "Pervaiz Tiwana", "Qaisar Bhatti", "Rafiq Jutt", "Sajid Tarar"
  ],
  nigeria: [
    "Chukwu Emeka", "Tunde Bakare", "Olumide Adekunle", "Emeka Nwosu", "Segun Okonkwo", "Ifeanyi Mbah",
    "Babatunde Lawal", "Obinna Chukwu", "Kayode Alabi", "Chinedu Igwe", "Damilola Oni", "Nnamdi Okafor",
    "Femi Ajao", "Gbenga Dosunmu", "Kunle Fashola", "Seyi Adeoye", "Olu Ajayi", "Tochukwu Aneke",
    "Bode Williams", "Adebayo Ogunleye", "Chidi Nnaji", "Adeola Akinwumi", "Ikenna Nwankwo", "Olawale Olayinka",
    "Ugochukwu Okafor", "Temitope Oladipo", "Kenechukwu Ibe", "Ayodele Adekunle", "Obiora Eze", "Olufemi Afolabi",
    "Ndubuisi Okeke", "Adewale Olatunji", "Chukwuma Okafor", "Ololade Oguntade", "Ikechukwu Nnaji", "Temidayo Adebayo",
    "Olayinka Adeniyi", "Adedayo Ojo", "Onyeka Nwankwo", "Olumuyiwa Bakare", "Chibuike Okafor", "Ayodeji Ogundimu",
    "Olalekan Oni", "Uche Nwosu", "Adekunle Adeola", "Chijioke Okeke", "Olumide Bakare", "Ifeanyi Igwe",
    "Femi Adewale", "Nonso Nwankwo", "Segun Oladele", "Obinna Eze", "Ayobami Ojo", "Kelechi Okeke",
    "Oluwaseun Bakare", "Tochukwu Nwosu", "Adegoke Akinola", "Chukwudi Okafor", "Olusola Adetunji", "Ikenna Igwe",
    "Temilolu Oni", "Olabode Afolabi", "Chibuzor Nwosu", "Ayomide Bakare", "Uchenna Obi", "Oluwafemi Ojo",
    "Sunday Okoh", "Monday Edet", "Friday Okon", "Godwin Udo", "Blessing Effiong", "Emmanuel Bassey",
    "Promise Akpan", "Success Etim", "Wisdom Inyang", "Favour Udoh", "Victory Essien", "Progress Ekpo",
    "Goodluck Ekanem", "Innocent Ita", "Patience Obot", "Happiness Umoh", "Destiny Ekong", "Fortune Udofia",
    "Prosper Ukpong", "Thankgod Iniobong", "Testimony Ndifreke", "Godspower Aniekan", "Godswill Emem", "Godslove Uduak",
    "Chuka Eze", "Musa Danjuma", "Ahmed Garba", "Ibrahim Sani", "Suleiman Yahaya", "Abdullahi Musa",
    "Yusuf Mohammed", "Hassan Garba", "Aliyu Mohammed", "Sanusi Lawal", "Kabir Suleiman", "Murtala Mohammed",
    "Usman Bello", "Shehu Abubakar", "Lawal Sani", "Nuhu Aliyu", "Gambo Suleiman", "Mustapha Umar",
    "Bala Mohammed", "Idris Bello", "Abubakar Garba", "Yakubu Suleiman", "Haruna Ibrahim", "Salisu Aliyu",
    "Mohammed Usman", "Adamu Bello", "Ismail Suleiman", "Garba Aliyu", "Bashir Ismail", "Nasiru Abdullahi",
    "Yaqub Suleiman", "Zakariya Musa", "Abubakar Sadiq", "Ibrahim Yakubu", "Musa Ibrahim", "Sani Abubakar",
    "Umar Suleiman", "Ahmad Bello", "Hamza Garba", "Yusuf Aliyu", "Jamilu Mohammed", "Kabiru Sani",
    "Lawali Ismail", "Muktar Usman", "Nasir Bello", "Abdulrahman Garba", "Buhari Mohammed", "Dikko Aliyu",
    "Farouk Suleiman", "Garba Umar", "Hamisu Bello", "Ibrahim Danjuma", "Jameel Sani", "Kabir Musa",
    "Lawal Garba", "Munir Aliyu", "Nasiru Usman", "Sanusi Mohammed", "Tijjani Bello", "Umar Sani",
    "Yahaya Garba", "Zayyanu Aliyu", "Abdullahi Usman", "Bature Mohammed", "Ciroma Bello", "Danladi Sani",
    "Ezekiel Okoro", "Felix Obi", "Gabriel Eze", "Henry Nweke", "Isaac Igwe", "James Okeke",
    "Kenneth Okafor", "Leonard Nwosu", "Michael Chukwu", "Nelson Okonkwo", "Oscar Nnaji", "Patrick Mbah",
    "Quincy Amadi", "Richard Eze", "Samuel Obi", "Thomas Okoro", "Uche Nweke", "Victor Igwe",
    "William Okeke", "Xavier Okafor", "Yves Nwosu", "Zach Chukwu", "Anthony Okonkwo", "Benedict Nnaji",
    "Clement Mbah", "Dennis Amadi", "Edward Eze", "Francis Obi", "George Okoro", "Hugh Nweke",
    "Ivan Igwe", "John Okeke", "Kevin Okafor", "Luke Nwosu", "Mark Chukwu", "Nathan Okonkwo",
    "Chidi Okoye", "Bola Adeleke", "Wale Adesina", "Kunle Adebisi", "Sola Oladele", "Tope Ajayi",
    "Bayo Oladipo", "Niyi Akindele", "Dele Ogunbiyi", "Kola Olawale", "Dayo Adeyemi", "Gbenga Oyedele"
  ],
  indonesia: [
    "Budi Santoso", "Agus Wijaya", "Hendra Kusuma", "Joko Susanto", "Dedi Suryadi", "Eko Prasetyo",
    "Bambang Setiawan", "Rizki Hidayat", "Adi Nugroho", "Tono Sudirman", "Hadi Pranoto", "Surya Atmaja",
    "Wahyu Firmansyah", "Arief Rahman", "Bayu Perdana", "Fajar Wibowo", "Rudi Hermawan", "Yanto Saputra",
    "Irwan Hakim", "Gunawan Salim", "Putra Mahendra", "Denny Pratama", "Andri Setiawan", "Heri Wibowo",
    "Syahrul Ramadan", "Teguh Prasetya", "Iwan Kurniawan", "Doni Saputra", "Rahmat Hidayat", "Yusuf Effendi",
    "Asep Supriyadi", "Hendri Gunawan", "Cecep Sudrajat", "Ujang Suhendar", "Dadang Hermawan", "Nana Suryana",
    "Tatang Sutisna", "Cucu Supriatna", "Eman Sulaeman", "Yayat Hidayat", "Entis Sutisna", "Usep Saepudin",
    "Aang Kunaefi", "Oding Sukarman", "Odin Sadikin", "Udin Samsudin", "Odang Suherman", "Maman Suparman",
    "Engkos Kosasih", "Endang Suhendar", "Atang Rusmana", "Usman Efendi", "Otong Sutisna", "Ade Hidayat",
    "Made Sudarsana", "Wayan Sudiarta", "Nyoman Sudirman", "Gede Suardana", "Komang Sudiasa", "Ketut Wirawan",
    "Putu Arjana", "Kadek Suardika", "Nengah Sudiana", "Mangku Pastika", "Gusti Ngurah", "Cokorda Bagus",
    "Anak Agung", "Ida Bagus", "Dewa Putu", "Sang Made", "Tjokorda Gde", "Sagung Rai",
    "Muhammad Rizky", "Ahmad Fauzi", "Abdullah Rahman", "Ibrahim Hassan", "Yusuf Habibi", "Ismail Hanafi",
    "Hamzah Akbar", "Hasan Basri", "Hussein Ali", "Zainal Abidin", "Karim Abdul", "Malik Ibrahim",
    "Nasir Udin", "Rasyid Ridho", "Taufik Hidayat", "Zaki Ahmad", "Bagus Prakoso", "Dimas Anggara",
    "Farhan Rizki", "Hasbi Assidiq", "Joni Iskandar", "Lukman Hakim", "Naufal Raziq", "Pandu Wijaya",
    "Ridwan Kamil", "Tegar Prasetyo", "Yudha Pratama", "Ananda Putra", "Chandra Wijaya", "Galih Permana",
    "Hendra Saputra", "Ilham Ramadan", "Jefri Kurniawan", "Kiki Setiawan", "Luki Hermawan", "Mulyadi Sutrisno",
    "Nurdin Rahman", "Opik Hidayat", "Panji Kusuma", "Qomar Santoso", "Rendi Wijaya", "Sigit Pramono",
    "Tomi Susanto", "Ujang Prasetyo", "Veri Setiawan", "Wawan Gunawan", "Yogi Hermanto", "Zainal Mutaqin",
    "Aris Budiman", "Banu Santoso", "Cahyo Wibowo", "Danang Prasetyo", "Endra Kurniawan", "Firman Setiawan",
    "Gilang Ramadan", "Heru Susanto", "Indra Wijaya", "Jaka Permana", "Krisna Murti", "Lanang Setiawan",
    "Maulana Hidayat", "Nur Rohman", "Okky Prasetyo", "Purnomo Sidi", "Rizal Kurniawan", "Setyo Budi",
    "Tri Wahyudi", "Umar Santoso", "Vino Gunawan", "Wawan Setiawan", "Yusuf Prasetyo", "Zaenal Arifin",
    "Agung Permana", "Bima Sakti", "Candra Kusuma", "Dedi Kurniawan", "Eko Santoso", "Feri Hidayat",
    "Guntur Prasetyo", "Hari Setiawan", "Ivan Kusuma", "Johan Permana", "Koko Setiawan", "Lutfi Hidayat",
    "Mamat Santoso", "Niko Prasetyo", "Oki Setiawan", "Pras Kusuma", "Riko Permana", "Sandi Hidayat",
    "Tedi Santoso", "Ujik Prasetyo", "Vicky Setiawan", "Wandi Kusuma", "Yudi Permana", "Zaki Hidayat",
    "Dodi Permadi", "Joni Hermanto", "Roni Budiman", "Toni Santoso", "Soni Kurniawan", "Doni Setiawan",
    "Poni Wijaya", "Boni Permana", "Coni Hidayat", "Foni Prasetyo", "Goni Susanto", "Honi Gunawan",
    "Joni Kusuma", "Koni Saputra", "Loni Hermawan", "Moni Sutrisno", "Noni Rahman", "Roni Prasetyo"
  ],
  philippines: [
    "Jose Garcia", "Juan Dela Cruz", "Pedro Mendoza", "Miguel Aquino", "Antonio Ramos", "Roberto Bautista",
    "Carlos Tan", "Francisco Lim", "Ramon Navarro", "Eduardo Sy", "Manuel Chua", "Ricardo Ong",
    "Alfredo Co", "Ernesto Yu", "Danilo Ng", "Benjamin Go", "Alejandro Kho", "Reynaldo Tan",
    "Leonardo Ang", "Rogelio Dy", "Armando Lee", "Gregorio Lim", "Fernando Uy", "Arturo Chua",
    "Rolando Yap", "Virgilio Tiu", "Alberto Chiong", "Edilberto Que", "Isidro Gaw", "Frederico Sia",
    "Marcelino Cojuangco", "Emilio Ayala", "Teodoro Araneta", "Herminio Lopez", "Andres Gotianun", "Enrique Razon",
    "Jaime Zobel", "Joseph Estrada", "Carlos Santos", "Felipe Reyes", "Gabriel Cruz", "Hector Torres",
    "Ignacio Flores", "Joaquin Rivera", "Leopoldo Castro", "Macario Domingo", "Narciso Ocampo", "Orlando Magsaysay",
    "Pablo Romulo", "Quirino Licuanan", "Rufino Yuchengco", "Salvador Gokongwei", "Tomas Lucio", "Ulysses Ongpin",
    "Vicente Ayala", "Wenceslao Locsin", "Abelardo Santos", "Bernardo Cruz", "Conrado Torres", "Dominador Flores",
    "Eliseo Rivera", "Feliciano Castro", "Gerardo Domingo", "Honorio Ocampo", "Ireneo Magsaysay", "Jovito Romulo",
    "Justino Licuanan", "Lamberto Yuchengco", "Marcelo Gokongwei", "Norberto Lucio", "Onofre Ongpin", "Perfecto Ayala",
    "Ramon Santos", "Sergio Cruz", "Teodulo Torres", "Urbano Flores", "Victorio Rivera", "Wilfredo Castro",
    "Adriano Domingo", "Benedicto Ocampo", "Cipriano Magsaysay", "Delfin Romulo", "Eugenio Licuanan", "Fortunato Yuchengco",
    "Graciano Gokongwei", "Hermogenes Lucio", "Ildefonso Ongpin", "Jacinto Ayala", "Laurencio Santos", "Maximino Cruz",
    "Nicanor Torres", "Osmundo Flores", "Pantaleon Rivera", "Rodolfo Castro", "Simplicio Domingo", "Tranquilino Ocampo",
    "Mark Reyes", "Jason Cruz", "Kevin Santos", "Bryan Torres", "Justin Flores", "Ryan Rivera",
    "Michael Castro", "David Domingo", "James Ocampo", "Robert Magsaysay", "William Romulo", "Richard Licuanan",
    "Joseph Yuchengco", "Thomas Gokongwei", "Charles Lucio", "Daniel Ongpin", "Matthew Ayala", "Anthony Santos",
    "Steven Cruz", "Paul Torres", "Andrew Flores", "Joshua Rivera", "Kenneth Castro", "George Domingo",
    "Edward Ocampo", "Brian Magsaysay", "Ronald Romulo", "Timothy Licuanan", "Jeffrey Yuchengco", "Frank Gokongwei",
    "Scott Lucio", "Raymond Ongpin", "Gregory Ayala", "Samuel Santos", "Patrick Cruz", "Jack Torres",
    "Dennis Flores", "Jerry Rivera", "Alexander Castro", "Tyler Domingo", "Jose Jr Ocampo", "Juan Jr Magsaysay",
    "Pedro Jr Romulo", "Miguel Jr Licuanan", "Antonio Jr Yuchengco", "Roberto Jr Gokongwei", "Carlo Santos", "Franco Cruz",
    "Marco Torres", "Paolo Flores", "Angelo Rivera", "Nico Castro", "Adrian Domingo", "Rafael Ocampo",
    "Dominic Magsaysay", "Vincent Romulo", "Cyrus Licuanan", "Julius Yuchengco", "Marcus Gokongwei", "Felix Lucio",
    "Armand Ongpin", "Bernard Ayala", "Cedric Santos", "Derek Cruz", "Edwin Torres", "Francis Flores",
    "Gerald Rivera", "Harold Castro", "Ivan Domingo", "Joel Ocampo", "Keith Magsaysay", "Larry Romulo",
    "Mario Santos", "Nestor Cruz", "Oscar Torres", "Peter Flores", "Quintin Rivera", "Roger Castro",
    "Simon Domingo", "Teddy Ocampo", "Victor Magsaysay", "Wilson Romulo", "Xavier Licuanan", "Yosef Yuchengco",
    "Zeno Gokongwei", "Aaron Lucio", "Barry Ongpin", "Calvin Ayala", "Danny Santos", "Erwin Cruz"
  ]
};

// Flatten all names into one pool
const ALL_NAMES = Object.values(NAME_POOLS).flat();

// Deposit amounts pool (mostly round numbers, rarely decimals)
const DEPOSIT_AMOUNTS = [5, 7, 10, 12, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 70, 80, 90, 100, 
  120, 150, 175, 200, 234, 250, 280, 300, 350, 400, 450, 500, 550, 600, 700, 800, 900, 1000, 1100, 1200];

// Generate random amount
const getRandomDepositAmount = () => {
  // 95% chance round number, 5% chance decimal
  if (Math.random() < 0.05) {
    const base = DEPOSIT_AMOUNTS[Math.floor(Math.random() * DEPOSIT_AMOUNTS.length)];
    return base + Math.random() * 0.99;
  }
  return DEPOSIT_AMOUNTS[Math.floor(Math.random() * DEPOSIT_AMOUNTS.length)];
};

const getRandomWithdrawAmount = () => {
  // Min $5, Max $300
  // 40% chance decimal, 60% round
  const amounts = [5, 8, 10, 12, 15, 18, 20, 25, 30, 35, 40, 45, 50, 60, 70, 80, 90, 100, 
    120, 140, 150, 175, 200, 220, 250, 280, 300];
  
  if (Math.random() < 0.4) {
    const base = amounts[Math.floor(Math.random() * amounts.length)];
    return base + Math.random() * 0.99;
  }
  return amounts[Math.floor(Math.random() * amounts.length)];
};

const getRandomName = () => ALL_NAMES[Math.floor(Math.random() * ALL_NAMES.length)];

// Realistic random delay - varied timing
const getRandomDelay = () => {
  const rand = Math.random();
  
  // 50% chance: Fast (1-3 seconds)
  if (rand < 0.50) {
    return Math.floor(Math.random() * 2000) + 1000; // 1-3 sec
  }
  // 35% chance: Medium (4-10 seconds)
  else if (rand < 0.85) {
    return Math.floor(Math.random() * 6000) + 4000; // 4-10 sec
  }
  // 15% chance: Slow (10-15 seconds)
  else {
    return Math.floor(Math.random() * 5000) + 10000; // 10-15 sec
  }
};

const LiveTransactionTicker = () => {
  const [currentTransaction, setCurrentTransaction] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const timeoutRef = useRef(null);

  const generateTransaction = () => {
    const isDeposit = Math.random() > 0.4; // 60% deposits, 40% withdrawals
    const name = getRandomName();
    const amount = isDeposit ? getRandomDepositAmount() : getRandomWithdrawAmount();
    
    return {
      name,
      type: isDeposit ? "deposit" : "withdraw",
      amount: amount.toFixed(amount % 1 === 0 ? 0 : 2)
    };
  };

  const showNextTransaction = () => {
    // Fade out current
    setIsVisible(false);
    
    setTimeout(() => {
      // Generate new transaction
      setCurrentTransaction(generateTransaction());
      // Fade in
      setIsVisible(true);
      
      // Schedule next transaction
      timeoutRef.current = setTimeout(showNextTransaction, getRandomDelay());
    }, 300);
  };

  useEffect(() => {
    // Start immediately
    setCurrentTransaction(generateTransaction());
    setIsVisible(true);
    timeoutRef.current = setTimeout(showNextTransaction, getRandomDelay());

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  if (!currentTransaction) return null;

  return (
    <div className="mx-4 mt-4 overflow-hidden">
      <div 
        className={`flex items-center justify-center gap-2 py-2 px-4 rounded-xl bg-gradient-to-r ${
          currentTransaction.type === "deposit" 
            ? "from-green-900/30 to-emerald-900/20 border border-green-500/30" 
            : "from-red-900/30 to-rose-900/20 border border-red-500/30"
        } transition-all duration-300 ${isVisible ? 'opacity-100 transform translate-y-0' : 'opacity-0 transform -translate-y-2'}`}
      >
        <span className={`w-2 h-2 rounded-full animate-pulse ${
          currentTransaction.type === "deposit" ? "bg-green-500" : "bg-red-500"
        }`}></span>
        
        <span className="text-sm font-medium text-white/90">
          {currentTransaction.name}
        </span>
        
        <span className={`text-sm font-bold ${
          currentTransaction.type === "deposit" ? "text-green-400" : "text-red-400"
        }`}>
          {currentTransaction.type === "deposit" ? "deposited" : "withdrew"}
        </span>
        
        <span className={`text-sm font-bold ${
          currentTransaction.type === "deposit" ? "text-green-300" : "text-red-300"
        }`}>
          ${currentTransaction.amount}
        </span>
        
        {currentTransaction.type === "deposit" ? (
          <span className="text-green-500 text-xs">↓</span>
        ) : (
          <span className="text-red-500 text-xs">↑</span>
        )}
      </div>
    </div>
  );
};

export default LiveTransactionTicker;
